// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import intvEntity from './entities/intv.json';
import intvMenu from '../pages/intv/menu.json';
import intvFullForm from '../pages/intv/forms/full.json';
import intvContextForm from '../pages/intv/forms/context.json';
import intvMiniForm from '../pages/intv/forms/mini.json';
import intvLookupForm from '../pages/intv/forms/lookup.json';
import intvTableView from '../pages/intv/views/table.json';
import intvStagesView from '../pages/intv/views/stages.json';
import intvCardsView from '../pages/intv/views/cards.json';
import intvInlineView from '../pages/intv/views/inline.json';
import intvBacklogView from '../pages/intv/views/backlog.json';
import intvSplitView from '../pages/intv/views/split.json';
import intvCalendarView from '../pages/intv/views/calendar.json';
import intvDashboardView from '../pages/intv/views/dashboard.json';

/** Тип запису «Інтерв’ю» зі сторінками пакета: меню, форми та подання з pages/intv/. */
export const intvDefinition: IRecordTypeDefinition = {
  ...intvEntity,
  views: assembleViewSet({
      table: intvTableView,
      stages: intvStagesView,
      cards: intvCardsView,
      inline: intvInlineView,
      backlog: intvBacklogView,
      split: intvSplitView,
      calendar: intvCalendarView,
      dashboard: intvDashboardView,
  }),
  form: intvFullForm,
  forms: { full: intvFullForm, context: intvContextForm, mini: intvMiniForm, lookup: intvLookupForm },
  menu: intvMenu,
} as IRecordTypeDefinition;
